import { ref } from 'vue';
import type { Extent } from 'ol/extent';
import { createMap, MapCalculationMode, useMap, useVectorMapLayer } from '@common';
import type { VectorMapLayerGroup } from '@common';
import { useModulesConfigStore } from '../../../store';

export const useStatisticsWizardMap = () => {
  const moduleStore = useModulesConfigStore();

  const map = createMap({
    id: 'statisticsDetailsMap',
    mapInfoEnabled: true,
    autoFitOnFirstLayerLoad: false,
    mapSourceUrl: moduleStore.moduleConfig.map.mapSourceURL,
    attributions: moduleStore.moduleConfig.map.attributions,
    calculationMode: MapCalculationMode.MERGED
  });

  const {
    layers,
    getLayer,
    addLayer,
    addSubLayer,
    enableZoneInteraction,
    disableZoneInteraction,
    updateMapInfos,
    fitExtentInView,
    clearLayers,
    switchSubLayer,
    removeLayer,
    fitMapExtentInView
  } = useMap(map);

  const isMapAutoFitEnabled = ref(true);
  const isZoneScrollIntoViewDisabled = ref(false);

  const zoomToExtent = (extent: Extent) => {
    fitExtentInView(extent);
  };

  const onZoneSelect = (layerId: string, zoneId: string) => {
    const layer = getLayer(layerId) as any as VectorMapLayerGroup;
    if (!layer) return;

    const composedLayer = useVectorMapLayer(layer.activeSubLayer);
    composedLayer.selectZone(zoneId);
  };

  const onZoneDeselect = (layerId: string) => {
    const layer = getLayer(layerId) as any as VectorMapLayerGroup;
    if (!layer) return;

    const composedLayer = useVectorMapLayer(layer.activeSubLayer);
    composedLayer.deselectAllZones();
  };

  return {
    map,
    layers,
    isMapAutoFitEnabled,
    isZoneScrollIntoViewDisabled,
    updateMapInfos,
    enableZoneInteraction,
    disableZoneInteraction,
    getLayer,
    addLayer,
    addSubLayer,
    removeLayer,
    clearLayers,
    switchSubLayer,
    zoomToExtent,
    fitMapExtentInView,
    onZoneSelect,
    onZoneDeselect
  };
};
